import { render, staticRenderFns } from "./UserMessageDetailInner.vue?vue&type=template&id=4bada86a&scoped=true&"
import script from "./UserMessageDetailInner.vue?vue&type=script&lang=js&"
export * from "./UserMessageDetailInner.vue?vue&type=script&lang=js&"
import style0 from "./UserMessageDetailInner.vue?vue&type=style&index=0&id=4bada86a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bada86a",
  null
  
)

export default component.exports